/*
  pl-parcela-unica (05/10/2026): "ou 1x de R$ 13,90 sem juros" embaixo do preço do Pix, nos itens baratos do carrinho.

  Pedido do Diogo: no carrinho, O Livro de Enoque (R$ 13,90) mostrava só "R$ 12,93 no Pix/boleto"; o Devocional
  Mulheres 2027 mostrava também, embaixo, "ou 2x de R$ 31,47 sem juros". Ele quer a linha do cartão nos dois.

  Como o tema funciona hoje (medido no carrinho real da prévia):
  - o item do carrinho é desenhado pelo pacote do tema (renderPrice), que só escreve a linha de parcelas quando o preço
    UNITÁRIO passa de installments_min_price (R$ 30 no varejo). O ajuste "mostrar parcela única"
    (installments_show_if_one, ligado no varejo) é lido ali, mas a condição não o usa;
  - a linha é pelo preço unitário: não muda quando a quantidade aumenta (Devocional com 2 unidades segue "2x de R$ 31,47").

  O pacote do tema não pode ser reconstruído (OPERACAO.md, "Risco estrutural"), então este arquivo completa por fora:
  para item do carrinho SEM a linha de parcelas, escreve a MESMA marcação que o tema escreveria, com todos os atributos.

  Duas armadilhas que derrubaram a 1ª versão (desfeita no mesmo dia):
  1. data-price do <product-price> sai multiplicado por 100 no carrinho real ("R$ 1.390,00" para um livro de R$ 13,90).
     O valor certo está em data-unformatted-price, em centavos. É dele que este arquivo lê.
  2. Quando preço ou quantidade mudam, o elemento de preço do tema pega o .info_installment de dentro dele e o reescreve
     a partir dos atributos data-*. Sem os atributos (contagem, parcela mínima, "mostrar parcela única") ele apaga o
     texto. Por isso a linha nasce com todos: depois disso é o próprio tema que a mantém certa.

  Inerte quando a loja não parcela ou quando "mostrar parcela única" está desligado (Atacado, Portugal).
*/
(function () {
  var S = (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) || {};
  if (S.show_installments === false || !S.installments_show_if_one) return;

  var ICONE = '<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 11.6666C0 12.9558 1.00688 13.9999 2.25 13.9999H15.75C16.9931 13.9999 18 12.9558 18 11.6666V5.83325H0V11.6666Z" fill="#868B93"></path><path d="M15.75 0H2.25C1.00688 0 0 1.04417 0 2.33333V4.66667H18V2.33333C18 1.04417 16.9931 0 15.75 0Z" fill="#868B93"></path></svg>';
  var agendado = false;

  function dinheiro(centavos) {
    var moeda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    var lingua = (window.Shopify && window.Shopify.locale) || 'pt-BR';
    try {
      return (centavos / 100).toLocaleString(lingua, { style: 'currency', currency: moeda });
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function frase(preco) {
    var L = window.LocalizedStrings && window.LocalizedStrings.price;
    if (!L) return '';
    var molde = S.installments_show_total_price
      ? (S.show_interest_free ? L.installments_with_total_interest_free : L.installments_with_total)
      : (S.show_interest_free ? L.installments_interest_free : L.installments);
    if (!molde) return '';
    return molde.replace(':::installments:::', '1').replace(':::installment_price:::', preco).replace(':::total_price:::', preco);
  }

  function completa() {
    agendado = false;
    var itens = document.querySelectorAll('cart-item product-price');
    for (var i = 0; i < itens.length; i++) {
      var pp = itens[i];
      if (pp.querySelector('.product-price__installments')) continue;   // o tema já escreveu (2x ou mais) ou já completei
      var centavos = Number(pp.getAttribute('data-unformatted-price'));
      if (!(centavos > 0)) continue;                                     // brinde ou preço escondido
      var caixa = pp.querySelector('.product-price__wrapper');
      if (!caixa) continue;
      var preco = dinheiro(centavos);
      var texto = frase(preco);
      if (!texto) continue;

      var p = document.createElement('p');
      p.className = 'info_installment';
      p.setAttribute('data-price', preco);
      p.setAttribute('data-installments-count', String(S.installments_count || 1));
      p.setAttribute('data-show-total-price', S.installments_show_total_price ? 'true' : 'false');
      p.setAttribute('data-installments-min-price', String(S.installments_min_price || 0));
      p.setAttribute('data-show-interest-free', S.show_interest_free ? 'true' : 'false');
      p.setAttribute('data-show-if-one', 'true');
      p.innerHTML = texto;

      var linha = document.createElement('div');
      linha.className = 'product-price__installments';
      linha.innerHTML = ICONE;
      linha.appendChild(p);
      caixa.appendChild(linha);
    }
  }

  function agenda() {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(completa);
  }

  function liga() {
    // O tema redesenha os itens a cada mudança do carrinho: observa só a gaveta e a página do carrinho.
    var raizes = document.querySelectorAll('.cart-drawer, .cart-page');
    var alvos = raizes.length ? raizes : [document.body];
    for (var i = 0; i < alvos.length; i++) {
      new MutationObserver(agenda).observe(alvos[i], { childList: true, subtree: true });
    }
    agenda();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga);
  else liga();
})();
